import types from './types';
import create from '~/misc/create';

import get from 'lodash/get';
import HTTPError from '~/misc/HTTPError';
import {promiseAction, ActionError} from '~/misc/dispatch';
import * as api from './api';
import {getAccount} from '../account/actions';

export const getAdminAccountInfo = (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.ADMIN_ACCOUNT_INFO,
  api.getAdminAccountInfoByEmail(getState).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
);

export const initAdminAccountInfo = (dispatch) => dispatch(create(types.ACCOUNT_INFO_INIT, {}));

export const getAccountList = (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.ACCOUNT_LIST,
  api.getAccountListBy2Email(getState).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
);

export const handleChangeUserRoleValue = (dispatch, getState, val) =>
  dispatch(create(types.USER_ROLE_CHANGE_VALUE, val));

export const saveUserRoleChange = (dispatch, getState, val) => {
  let isSelf = val.isSelf ? true : false;
  return promiseAction(
    dispatch,
    getState,
    types.SAVE_USER_ROLE_CHANGE,
    api.changeUserRoleApi(getState, val).catch(error => {
      if (!(error instanceof HTTPError)) {
        throw error;
      }
      return error.response.json().then(body => {
        const e = get(body, 'api_errors', [])[0] || {};
        if (e.type === 'auth' && e.value === 'token_invalid') {
          throw new ActionError('token_invalid');
        }
        throw error;
      });
    }),
    val
  ).then(() => isSelf && getAccount(dispatch, getState))
};

export const deleteUser = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.DELETE_ACCOUNT_USER,
  api.deleteAccountUserApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  }),
  val
);

export const addUserToAccount = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.ADD_ACCOUNT_USER,
  api.addAccountUserApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  }),
  val
);

export const deleteUserAndGetNewUserList = (dispatch, getState, val) => {
  let isSelf = val.isSelf ? true : false;
  return promiseAction(
    dispatch,
    getState,
    types.DELETE_ACCOUNT_USER_AND_GET_NEW_LIST,
    deleteUser(dispatch, getState, val),
    val
  ).then(() => isSelf ? getAccount(dispatch, getState) : getAccountList(dispatch, getState));
}

export const addUserToAccountAndGetNewList = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.ADD_ACCOUNT_USER_AND_GET_NEW_LIST,
  addUserToAccount(dispatch, getState, val).then(() => getAccountList(dispatch, getState)),
  val
);

export const hideAsyncErrorMessage = (dispatch, val) => dispatch(create(types.ASYNG_ERROR_HIDE, val));





// WEBPACK FOOTER //
// ./src/modules/adminAccountPage/actions.js